import styled, { keyframes } from 'styled-components';
import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';
import { Card } from 'components/Card/styles';
import { Container as InputContainer } from 'components/Input/styles';

interface TabsProps {
  $activeIndex: number;
}
interface ItemProps {
  disabled: boolean;
  hasInsercao: boolean;
}

export const Content = styled.div`
  display: flex;
  padding: 1rem 0 0 0;
  height: calc(100vh - 139px);
  color: ${({ theme }) => theme.fontColor};

  ${Card} {
    header {
      padding: 0 !important;
      h6 {
        padding: 0 !important;
        font-size: 0.9rem;
        font-weight: 600;
        letter-spacing: 0.03rem;
      }
    }

    &:nth-child(1) {
      flex: 0.4;
      padding: 0.6rem 0 0 0;
      form {
        padding: 0 0.6rem;
      }
    }

    &:nth-child(2) {
      margin: 0 0.5rem;
      flex: 0.4;
      padding: 0.4rem;

      ul {
        padding: 0 !important;
        li {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          div {
            display: flex;
            align-items: baseline;
            justify-content: start;

            strong {
              font-size: 0.8rem !important;
              display: flex;
              align-items: center;
              &:after {
                content: '';
                border-radius: 100%;
                width: 4px;
                height: 4px;
                margin: 0 4px;
                background-color: ${({ theme }) => theme.fontColor};
              }
            }
          }

          span {
            font-size: 0.6rem;
            font-style: italic;
            opacity: 0.6;
            max-width: 90%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    &:nth-child(3) {
      flex: 1;
      padding: 0.6rem;
      form {
        overflow: auto;

        div.row {
          display: flex;
          align-items: baseline;
          padding: 0.2rem 0;
          > label {
            min-width: 11rem;
            font-weight: 400;
            font-size: 0.8rem;
            padding: 0 !important;
            letter-spacing: 0rem;
            opacity: 0.8;
          }

          ${InputContainer} {
            width: -webkit-fill-available;
            height: 40px !important;
          }

          &:first-child {
            margin-top: 1rem;
          }
        }

        section {
          display: flex;

          flex-direction: column;
          label {
            font-size: 0.8rem;
            font-weight: 600;
            letter-spacing: 0.03rem;
            margin: 1rem 0 0.5rem;
          }

          .rmdp-wrapper {
            margin: 0 auto !important;
          }
          .calendario {
            display: flex;
            justify-content: space-around;
            > div {
              display: flex;
              flex-direction: column;
              align-items: center;
              label {
                margin-bottom: 5px;
              }
            }
          }
        }

        .submitButton {
          width: 200px;
          margin: 1rem 0 0 auto;
        }
      }
    }
  }

  ul {
    padding: 0 0.4rem;
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      padding: 0.6rem;
      cursor: pointer;

      transition-property: opacity, background-color;
      transition-duration: 0.3s;

      border-bottom: 1px solid ${props => props.theme.backgroundSecondary};

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      p {
        max-width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &.active {
        background-color: ${({ theme }) => theme.hover};
      }

      svg {
        position: absolute;
        min-width: 1rem;
        top: calc(50% - 0.5rem);
        right: 0.4rem;
        margin-right: 0px;
        transition: all 0.2s ease-in-out;
      }

      &:hover {
        background-color: ${({ theme }) => theme.hover};
        opacity: 0.9;

        svg {
          margin-right: -5px;
        }
      }
    }
  }

  .bg-dark.rmdp-wrapper {
    border: none;
    background-color: ${({ theme }) => theme.hover};

    .rmdp-week-day,
    .rmdp-arrow {
      color: ${({ theme }) => theme.button.primary.out};
    }

    .highlight-red {
      color: ${({ theme }) => theme.button.danger.in};
    }

    .rmdp-selected span {
      box-shadow: none;
    }

    .rmdp-selected .highlight-red {
      color: ${({ theme }) => theme.fontColor};
    }

    .rmdp-day.rmdp-today {
      span {
        background: ${({ theme }) => theme.datepicker.today};
      }
    }
    .rmdp-day.rmdp-today.rmdp-selected {
      span {
        background: ${({ theme }) => theme.datepicker.selected};
      }
    }
  }
`;

export const Anexo = styled.div`
  width: 100%;
  height: 5rem;
  background-color: ${({ theme }) => theme.hover};
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  margin: 0 0 1rem;

  button {
    margin-right: 10px !important;
    width: 50px !important;
  }
  .attach-thumb {
    width: 6rem;
    height: 5rem;
    background-color: #c94f5c;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: ${({ theme }) => theme.lightFontColor};
      font-weight: 500;
      font-size: 1.5rem;
      opacity: 1;
    }
  }

  div.attach-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0.4rem 1rem;
    span {
      opacity: 0.6;
      &:first-of-type {
        padding: 0.2rem 0;
      }
    }
  }
`;

export const fadeIn = keyframes`
0% {
   width: 0;
 }

 100% {
  width: 100%;
 }
`;

export const Tabs = styled.div<TabsProps>`
  button {
    background: transparent;
    border: none;
    color: ${props => props.theme.fontColor};
    margin-top: 1rem;
    padding: 0.5rem 0.2rem;
    position: relative;

    transition: font-weight 0.2 ease-in-out;

    /* &:first-of-type { */
    margin-right: 1rem;
    /* } */

    &:nth-child(${({ $activeIndex }) => $activeIndex}) {
      font-weight: 600;
      &::before {
        animation: ${fadeIn} 0.2s forwards;
        content: '';
        position: absolute;
        height: 2px;
        width: 100%;
        bottom: -2px;
        background-color: ${({ theme }) => theme.fontColor};
      }
    }
  }
`;

export const ModalContent = styled.div`
  align-self: center;
`;

export const MapaList = styled.li<ItemProps>`
  ${({ disabled }) => disabled && `text-decoration: line-through`};
  ${({ hasInsercao }) => !hasInsercao && `opacity: 30%`};
  strong,
  p,
  span {
    ${({ hasInsercao }) => !hasInsercao && `opacity: 30%`};
  }
`;
